import { useEffect, useState } from "react"

// can set default delay = 500
const useDebounce = (value, delay) => {
    const [debouncedValue, setDebouncedValue] = useState(value)

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value)
        }, delay)

        return () => {
            clearTimeout(handler)
        }

    }, [value, delay])

    return debouncedValue
}
export default useDebounce